<template >
     <el-form :model="form" ref="form"  label-width="120px" class="demo-dynamic">

    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>时间规则</span>
            <p>请谨慎点击,保存后会修改库存!</p>
            <el-button @click="addDomain('rule')" size="mini" type="primary">新增+</el-button>
            <br>
            <br>
            <el-tag type="danger">24小时制，如10：00-20：30</el-tag>
            <br>
            <br>
        </div>

        <div class="text item">
            <el-card class="box-card" v-for="(item, index) in form.rule" :key="item.key">
                <el-button type="danger" size="mini" v-if="index > 0"
                    @click.prevent="removeDomain(item, 'rule')">移除X</el-button>
                <el-form-item :label="'执行类型'" :prop="'rule.' + index + '.type'"  >
                        <el-radio v-model="item.type" size="mini" label="time" border>按每日时间执行</el-radio>
                        <el-radio v-model="item.type" size="mini" label="date" border>按选择日期执行</el-radio>
                </el-form-item>

               <div >
                 <el-form-item v-if="item.type =='date'" :label="'起始日期'" :prop="'rule.' + index + '.start_date'" style="display: inline-block;">
                      <el-date-picker
                        size="mini"
                           v-model="item.start_date"
                           type="date"
                           placeholder="起始日期">
                         </el-date-picker>
                 </el-form-item>
                 <el-form-item v-else :label="'起始时间'" :prop="'rule.' + index + '.start'" :rules="[
                     { required: true, message: '起始时间不能为空' },
                 ]" style="display: inline-block;">
                     <el-time-select size="mini" v-model="item.start" :picker-options="{
                         start: '00:00',
                         step: '00:01',
                         end: '23:59'
                     }" placeholder="请输入起始时间">
                     </el-time-select>
                 </el-form-item>
                 <el-form-item  v-if="item.type =='date'" :label="'终止日期'" :prop="'rule.' + index + '.end_date'" style="display: inline-block;">
                      <el-date-picker
                      size="mini"
                           v-model="item.end_date"
                           type="date"
                           placeholder="选择日期">
                         </el-date-picker>
                 </el-form-item>
                 <el-form-item v-else :label="'终止时间'" :prop="'rule.' + index + '.end'" :rules="[
                     { required: true, message: '终止时间不能为空' },
                 ]" style="display: inline-block;">
                     <el-time-select size="mini" v-model="item.end" :picker-options="{
                         start: '00:00',
                         step: '00:01',
                         end: '23:59'
                     }" placeholder="请输入终止时间">
                     </el-time-select>
                 </el-form-item>
               </div>
                <div  style="display: flex;flex-wrap: wrap;">
                    <div v-for="(val,i) in options" :key="i" style="display: inline-block;width:25%;">
                        <el-form-item :label="val.title"  >
                            <el-input v-model.number="item.number[i].value" size="mini" type="text" maxlength="5" show-word-limit
                                placeholder="请输入数量" ></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-card>
        </div>
    </el-card>
    <el-form-item style="text-align: center;">
          <el-button type="primary" @click="onSubmit('form')" size="mini">保存</el-button>
          <el-button @click="resetForm('form')" size="mini">重置</el-button>
        </el-form-item>
</el-form>
</template>

<script>
import {
    setRandCardRule,
    getRandCard
} from "../../../api/cardticket";

export default {

    data() {
        return {
            form:{
                rule: [{
                    type:"time",
                    start_date:"",
                    end_date:"",
                    start:"00:00",
                    end:"11:00",
                    number:[
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                    ]
                }],
            },
            rule: {
                    start:"00:00",
                    end:"11:00",
                    number:[
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                       {value:100},
                    ]
                },
            options:[],
        }
    },
    methods: {
    getRandCardList(){
        getRandCard().then((res) => {
        this.options = res.data.data.list;
        var len = this.options.length;
        if(res.data.data.rule.length >0){
            this.form.rule = res.data.data.rule
        }else{
            for(let i=0;i<len;i++){
              this.form.rule[0].number.push({value:100});
              this.rule.number.push({value:100});
            }
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item,rule) {

      this.$confirm("此操作将会移除此项是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
           var index = this.form[rule].indexOf(item)
           if (index !== -1) {
             this.form[rule].splice(index, 1)
           }
        })
        .catch(() => {});
    },
    addDomain(rule) {
      this.form[rule].push(this.rule);
    },
    onSubmit(formName) {
      console.log(this.form);
      var submit = false;
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log(this.form)
          console.log("error submit!!");
          return false;
        } else {
          submit = true;
        }
      });
      if (submit == false) {
        return;
      }

      setRandCardRule(this.form).then((res) => {
          if (res.status) {
            this.loading = false;
            this.$message({
            message: "保存成功",
            type: "success",
            duration: 2000,
            });
          } else {
            this.$message.error("保存失败!");
            return false;
          }
        });
    },
    },
    mounted() {
        this.getRandCardList();
    }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// setRandCardRule.vue?544046d8